export default __webpack_public_path__ + "static/media/Landing_page.3819f3a9.jpg";